import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

const API_URL = environment.apiUrl + "api/";

@Injectable()
export class ApiRoutes{
    herokuAPI: string = "https://api-codigos-postales.herokuapp.com/v2/codigo_postal/";
    customers: string = API_URL + "client";
    geoWebState: string = 'http://geoweb2.inegi.org.mx/wscatgeo/mgee/buscar/';
    geoWebCounty: string = 'http://geoweb2.inegi.org.mx/wscatgeo/mgem/buscar/';
    geoWebLocality: string = 'http://geoweb2.inegi.org.mx/wscatgeo/localidades/'; // Requiere cve_agee (Estado) y cve_agem (Municipio)
    geoWebNeighborhood: string = 'http://geoweb2.inegi.org.mx/wscatgeo/asentamientos/'; // Requiere cve_agee (Estado) y cve_agem (Municipio)
    geoWebStreet: string = 'http://geoweb2.inegi.org.mx/wscatgeo/vialidades/'; // Requiere cve_agee (Estado) y cve_agem (Municipio)
}